<template>
    <div ref="comms_pref_container">
        <div class="mb-5">
            <h2
                class="form-sub-header text-green text-2xl font-bold w-full focus:outline-none"
            >
                Let’s stay in touch
            </h2>
        </div>
        <div class="mb-5">
            <p
                class="font-medium m-0"
                style="font-size: 13px; line-height: 146%;"
            >
                We would like to stay in touch with you about <span class="sm:hidden"><br></span><a href="javascript:void(0)" class="other-products-services">other products, services</a> and hints and tips which could be useful for you.
            </p>
        </div>
            <digi-multi-selection
            :options="{
                    'email':{
                        'label' : 'Email',
                        'icon' : '/img/icons/email.png'
                    }, 
                    'sms':{
                        'label' : 'SMS',
                        'icon' : '/img/icons/sms.png'
                    },
                    'whatsapp': {
                        'label' : 'WhatsApp',
                        'icon' : '/img/icons/whatsapp.png'
                    }
                }"
                label="We would like to share these 
                by:"
                name="communication_preferences_test"
                options_per_row="3"
                v-model="values"
                class="mb-8"
                type="toggle"
                tooltip="We will not share any of your contact information with third parties for marketing purposes and we will never call you."

            >
            </digi-multi-selection>
        <div class="mb-5">
            <p
                class="font-medium m-0"
                style="font-size: 13px; line-height: 146%;"
            >
                You can change your communication preferences and unsubscribe at any time by contacting us.
            </p>
        </div>
    </div>
</template>
<script>
export default {
    inject: [ '$getValidationRules', '$getValidationMessages', '$globals', '$customer'],
    components: {
        'digi-multi-selection': require('./digi-multi-selection').default
    },
    data() {
        return {
            text: '',
            values: [],
        };
    },
    computed: {
        consents() {
            return {
                communication_preference_email: {
                    url: location.href,
                    consent_given: this.values.includes('email'),
                    text: this.text
                },
                communication_preference_sms: {
                    url: location.href,
                    consent_given: this.values.includes('sms'),
                    text: this.text
                },
                communication_preference_whatsapp: {
                    url: location.href,
                    consent_given: this.values.includes('whatsapp'),
                    text: this.text
                },
            };
        }
    },
    props: {
        value: Object,
    },
    watch: {
        'values': {
            immediate: true,
            handler() {
                this.populateText();
                this.doUpdate();
            }
        }
    },
    methods: {
        doUpdate() {
            this.$set(this.$customer, 'consents', this.$customer.consents || {});
            this.$set(this.$customer.consents, 'communication_preference_email', this.consents.communication_preference_email);
            this.$set(this.$customer.consents, 'communication_preference_sms', this.consents.communication_preference_sms);
            this.$set(this.$customer.consents, 'communication_preference_whatsapp', this.consents.communication_preference_whatsapp);
        },
        populateText() {
            if (this.$refs.comms_pref_container) {
                this.text = this.$refs.comms_pref_container.innerText;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.populateText();
            this.doUpdate();
        });
    },
    updated() {
        this.$nextTick(() => {
            this.populateText();
            this.doUpdate();
            window.amplitude.formConsentInteractionEvent(
                this.$customer.consents.communication_preference_email.consent_given,
                this.$customer.consents.communication_preference_sms.consent_given,
                this.$customer.consents.communication_preference_whatsapp.consent_given
            )
        });
    }
}
</script>

<style lang="scss"></style>
